// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"65128ae7","513":"f5145f4e","703":"5e5d34a7"}[chunkId] + ".chunk.js";
};